<script lang="ts">
    import {_} from 'svelte-i18n';

    import type { AssignmentJob } from '../AssignmentJob';
    import DisplayAddressText from './DisplayAddressText.svelte';
    import IconJobRejected from '../../../shared/Icons/IconJobRejected.svelte';
    import IconRouteInProgress from '../../../shared/Icons/IconRouteInProgress.svelte';
    import IconAdd from '../../../shared/Icons/IconAdd.svelte';
    import InfoColor from '../../../shared/InfoColor.svelte';
    import { getJobColor } from '../../Jobs/getJobColor';
    import DisplayLabel from '../../Jobs/DisplayLabel.svelte';
    import IconDoNotDisturbOn from '../../../shared/Icons/IconDoNotDisturbOn.svelte';
    import JobTypeIcon from '../../Jobs/JobTypeIcon.svelte';
    import WarningColor from '../../../shared/WarningColor.svelte';
    import { debug } from '../../../../stores/store';
    import { app } from '../../../../stores/app';
    import { features } from '../../../shared/Features/features';
    import { Liquid } from 'liquidjs';
    import DisplayJobDescriptionText from './DisplayJobDescriptionText.svelte';

    export let assignmentJob: AssignmentJob;
    export let flexColumn: boolean = false;
    export let nextAddressOnRoute: boolean = false;

    let city: string, street: string, house: string;
    let x: string | null, y: string | null;
    let label: string | null;
    let text: string, subtext: string;
    let rejected: boolean = false;

    let recentJobData: string = '';

    // console.log('DisplayAddress', assignmentJob);

    function formatGPSCoordinate(type: string, value: number) {
        let cdeg = '';
        let deg = value;
        let sign = deg < 0 ? -1 : 1;
        deg = Math.abs(deg);
        let gpsdeg = Math.floor(deg);
        let remainder = deg - (gpsdeg * 1);
        let gpsmin = remainder * 60;
        remainder = gpsmin - Math.floor(gpsmin)*1;
        let gpssec = remainder * 60;
        cdeg = gpsdeg+'°'+Math.floor(gpsmin)+"'"+(Math.round(10*Math.floor(gpssec*100)/100)/10)+'"'+(sign > 0 ? (type == 'x' ? 'E' : 'N') : (type == 'x' ? 'W' : 'S'));
        return cdeg;
    }

    $: {
        x = typeof(assignmentJob.getJob()?.geom?.coordinates[0]) === 'number' ? formatGPSCoordinate('x', assignmentJob.getJob()?.geom.coordinates[0] || 0) : null;
        y = typeof(assignmentJob.getJob()?.geom?.coordinates[1]) === 'number' ? formatGPSCoordinate('y', assignmentJob.getJob()?.geom.coordinates[1] || 0) : null;
        if ($features.feature_configurable_job_description) {
            let jobData = {
                ...assignmentJob.getJob(),
                coords: typeof(x) === 'string' && typeof(y) === 'string' ? y + ', ' + x : ''
            };
            let jobDataString = JSON.stringify(jobData);
            if (recentJobData != jobDataString) {
                let jobDescriptionTemplates = $app.account.getSettingsReadonly().job_description;
                let liquidEngine = new Liquid();
                label = liquidEngine.parseAndRenderSync(jobDescriptionTemplates.label, jobData);
                text = liquidEngine.parseAndRenderSync(jobDescriptionTemplates.text, jobData);
                subtext = liquidEngine.parseAndRenderSync(jobDescriptionTemplates.subtext, jobData);
            }
        } else {
            city = assignmentJob.getCity();
            street = assignmentJob.getStreet();
            house = assignmentJob.getHouse();
            label = assignmentJob.getJob()?.special_attributes?.label ?? null;
        }

        rejected = assignmentJob.getJobClass()?.isRejected() ?? false;
    }

    $: {
        nextAddressOnRoute = nextAddressOnRoute;
    }
</script>

<!--<DisplayAddressText {city} {street} {house} {x} {y} {flexColumn} {label} />-->


{#if !flexColumn}
<!--    <JobTypeIcon-->
<!--        type={delivery_or_collection}-->
<!--        scale={0.6}-->
<!--        color={getJobColor(job.getData(), null)}-->
<!--    />-->
    <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        {#if $features.feature_configurable_job_description}
            <DisplayJobDescriptionText
                label={(label || '')}
                {text}
                {subtext}
                flexColumn={flexColumn}
            />
        {:else}
            <DisplayAddressText
                {city}
                {street}
                {house}
                {x}
                {y}
                label={null}
                flexColumn={flexColumn}
            />
        {/if}
    </div>
    <div style="display: flex; margin-left: auto;column-gap: 3px; margin-right: 3px; align-items: center;">
        <!--{#if job.ad_hoc}-->
        <!--    <IconFlashOn scale={0.5} title={$_('Ad-hoc')} />-->
        <!--{/if}-->
        {#if !$features.feature_configurable_job_description}
            <div><DisplayLabel {label}/></div>
        {/if}
        {#if nextAddressOnRoute || $debug}
            <!-- /*nextRoutePointJobId.includes(assignmentJob.getJobId()) || $debug*/ -->
            <IconRouteInProgress title={$_('Next address on route')} />
        {/if}
        {#if assignmentJob.getJob()?.newly_added || $debug}
            <InfoColor>
                <IconAdd scale={0.5} title={$_('Newly added')} />
            </InfoColor>
        {/if}
        {#if rejected}
            <IconJobRejected job={assignmentJob.getJobClass()} />
        {/if}
    </div>
{:else}
<!--    <div>-->
<!--&lt;!&ndash;        <JobTypeIcon&ndash;&gt;-->
<!--&lt;!&ndash;            type={delivery_or_collection}&ndash;&gt;-->
<!--&lt;!&ndash;            scale={0.6}&ndash;&gt;-->
<!--&lt;!&ndash;            color={getJobColor(job.getData(), null)}&ndash;&gt;-->
<!--&lt;!&ndash;        />&ndash;&gt;-->
<!--    </div>-->
    <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        {#if $features.feature_configurable_job_description}
            <DisplayJobDescriptionText
                label={(label || '')}
                {text}
                {subtext}
                flexColumn={flexColumn}
            />
        {:else}
            <DisplayAddressText
                {city}
                {street}
                {house}
                {x}
                {y}
                {label}
                flexColumn={flexColumn}
            />
        {/if}
    </div>
    <div style="display: flex; margin-left: auto;column-gap: 3px;">
        {#if nextAddressOnRoute || $debug}
            <!-- /*nextRoutePointJobId.includes(assignmentJob.getJobId()) || $debug*/ -->
            <IconRouteInProgress title={$_('Next address on route')} />
        {/if}
        {#if assignmentJob.getJob()?.newly_added || $debug}
            <InfoColor>
                <IconAdd scale={0.5} title={$_('Newly added')} />
            </InfoColor>
        {/if}
        {#if assignmentJob.getJobClass()?.isRejected() || $debug}
            <IconJobRejected job={assignmentJob.getJobClass()} />
        {/if}
    </div>
{/if}



<!--
            <div style="display: flex; flex: 0 1 auto; flex-direction: row;">
            </div>
            <div style="display: flex; flex: 1 0 auto; margin-left: auto; column-gap: 3px; margin-right: 3px">
{#if nextRoutePointJobId.includes(assignmentJob.getJobId()) || $debug}
    <IconRouteInProgress title={$_('Next address on route')} />
{/if}
{#if assignmentJob.getJob()?.newly_added || $debug}
    <InfoColor>
        <IconAdd scale={0.5} title={$_('Newly added')} />
    </InfoColor>
{/if}
{#if assignmentJob.getJobClass()?.isRejected() || $debug}
    <IconJobRejected job={assignmentJob.getJobClass()} />
{/if}
</div>

-->